import { AttributeType, SugarAttributeInfo } from "../../SugarElementInfo";

export const pathAttribute: SugarAttributeInfo = {
    name: "path",
    valueTypes: [AttributeType.Path],
};
